import './new-card-category.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormCardCategory from "../form-card-category/form-card-category";
import { useNewCardCategory } from './new-card-category.hook';

export function NewCardCategory() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewCardCategory();

  return (
    <div id="NewCardCategory" className="card-category">
      <HeaderContent
        title={<h1>New Card Category</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormCardCategory />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewCardCategory;